import React from "react";
import { Card, CardBody, Table, Badge, Button } from "reactstrap";
import { injectIntl } from "react-intl";
import axios from "axios";
import moment from "moment";
import { NotificationManager } from "../../../../components/common/react-notifications";
import { END_POINT } from "../../../../constants/defaultValues";

const StockDisposalList = ({
  intl,
  data = [],
  onViewDetail,
  isAdmin = false,
  onRefresh,
}) => {
  const handleApprove = async (disposalId) => {
    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.post(
        `${END_POINT}/api/stock-disposal/${disposalId}/approve`,
        {},
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (response.data.status === 200) {
        NotificationManager.success(
          "Duyệt phiếu tiêu hủy thành công",
          "Thành công"
        );
        onRefresh && onRefresh();
      } else {
        NotificationManager.error(response.data.responseText, "Lỗi");
      }
    } catch (error) {
      NotificationManager.error("Có lỗi xảy ra", "Lỗi");
    }
  };

  const handleReject = async (disposalId) => {
    if (!window.confirm("Bạn có chắc muốn từ chối phiếu tiêu hủy này?")) return;

    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.post(
        `${END_POINT}/api/stock-disposal/${disposalId}/reject`,
        {},
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (response.data.status === 200) {
        NotificationManager.success("Đã từ chối phiếu tiêu hủy", "Thành công");
        onRefresh && onRefresh();
      } else {
        NotificationManager.error(response.data.responseText, "Lỗi");
      }
    } catch (error) {
      NotificationManager.error("Có lỗi xảy ra", "Lỗi");
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "pending":
        return <Badge color="warning">Chờ duyệt</Badge>;
      case "approved":
        return <Badge color="info">Đã duyệt</Badge>;
      case "completed":
        return <Badge color="success">Hoàn thành</Badge>;
      case "rejected":
        return <Badge color="danger">Từ chối</Badge>;
      default:
        return <Badge color="light">{status}</Badge>;
    }
  };

  const getTypeBadge = (type) => {
    switch (type) {
      case "expired":
        return <Badge color="danger">Hết hạn</Badge>;
      case "damaged":
        return <Badge color="warning">Hư hỏng</Badge>;
      case "other":
        return <Badge color="secondary">Khác</Badge>;
      default:
        return <Badge color="light">{type}</Badge>;
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(value || 0);
  };

  if (data.length === 0) {
    return (
      <Card className="mb-4">
        <CardBody className="text-center text-muted">
          <i
            className="iconsminds-delete-file"
            style={{ fontSize: "48px" }}
          ></i>
          <p className="mt-3">Chưa có phiếu tiêu hủy nào</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="mb-4">
      <CardBody>
        <Table hover responsive>
          <thead>
            <tr>
              <th style={{ verticalAlign: "middle" }}>Mã phiếu</th>
              <th style={{ verticalAlign: "middle" }}>Ngày</th>
              <th className="text-center" style={{ verticalAlign: "middle" }}>
                Loại
              </th>
              <th className="text-center" style={{ verticalAlign: "middle" }}>
                Số nguyên liệu
              </th>
              <th className="text-center" style={{ verticalAlign: "middle" }}>
                Nhà cung cấp
              </th>
              <th className="text-right" style={{ verticalAlign: "middle" }}>
                Giá trị
              </th>
              <th className="text-center" style={{ verticalAlign: "middle" }}>
                Trạng thái
              </th>
              <th style={{ verticalAlign: "middle" }}></th>
            </tr>
          </thead>
          <tbody>
            {data.map((disposal) => (
              <tr key={disposal.id}>
                <td style={{ verticalAlign: "middle" }}>
                  <strong>{disposal.disposal_code}</strong>
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  {moment(disposal.disposal_date).format("DD/MM/YYYY")}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {getTypeBadge(disposal.disposal_type)}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {disposal.items?.length || 0}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {(() => {
                    const names = (disposal.items || [])
                      .map((i) => i.provider?.name)
                      .filter(
                        (val, idx, self) => val && self.indexOf(val) === idx
                      );
                    return names.length > 0 ? names.join(", ") : "-";
                  })()}
                </td>
                <td
                  className="text-right text-danger"
                  style={{ verticalAlign: "middle" }}
                >
                  {formatCurrency(disposal.total_value)}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {getStatusBadge(disposal.status)}
                </td>
                <td className="text-right" style={{ verticalAlign: "middle" }}>
                  {isAdmin && disposal.status === "pending" && (
                    <>
                      <Button
                        color="success"
                        size="sm"
                        className="mr-1"
                        onClick={() => handleApprove(disposal.id)}
                      >
                        Duyệt
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleReject(disposal.id)}
                      >
                        Từ chối
                      </Button>
                    </>
                  )}
                  <Button
                    color="link"
                    size="sm"
                    onClick={() => onViewDetail && onViewDetail(disposal)}
                  >
                    Chi tiết
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default injectIntl(StockDisposalList);
